module.exports = __webpack_public_path__ + "static/media/loading.71d5eb45.svg";


//////////////////
// WEBPACK FOOTER
// ./src/arteia-js/components/Loading/loading.svg
// module id = 218
// module chunks = 0